import React, { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import { AGENT_CATEGORIES } from "@lib/agentConsole";
import type { I18nT } from "@lib/dashboardI18n";

const StandardsForNRO = lazy(() =>
  import("@scenes/AgentsList").then((module) => ({
    default: () => React.createElement(module.AgentConsoleForNro, { category: AGENT_CATEGORIES.QA }),
  }))
);

export const standardsNRO: NavigationRoutingObject = {
  Component: StandardsForNRO,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "agent-console",
  icon: "new-nav-system-agent-management",
  heading: (t: I18nT<"dashboard-navigation">) => t("qa-agents-nro-heading", "Agentic Standards"),
  pageNameForTracking: () => "Agentic Standards",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("qa-agents-nro-description", "Check campaigns, Canvases, and content against custom rules before launch"),
  // Either Standards flipper allows navigation, matching the side-nav entry
  // (AgentConsoleMenuItems shows Agentic Standards on campaignQa || canvasQa),
  // so a canvas-only workspace no longer navigates to a 404.
  getDeveloperNavigationAllowed: ({ featureOn }) =>
    featureOn("agent_console_campaign_qa") || featureOn("agent_console_canvas_qa"),
  // Legacy names so existing muscle memory still surfaces this page in global
  // search after the Agentic Standards rename.
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("standards-search-qa-agent", "QA Agent"), t("standards-search-qa-agents", "QA Agents")],
      description: t("standards-search-legacy-description", 'Previously "QA Agents"'),
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
